// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5977) return "js/chunk.npm-async-core-js.302ced9a.js";
	if (chunkId === 230) return "js/chunk.npm-async-intl-segmenter-polyfill-rs.30e64cd0.js";
	if (chunkId === 8335) return "js/chunk.app-async.93e32105.js";
	if (chunkId === 2211) return "js/chunk.2211.4ebe37ec.js";
	if (chunkId === 7274) return "js/chunk.7274.0eb34bc5.js";
	if (chunkId === 4187) return "js/chunk.4187.321fa702.js";
	if (chunkId === 7763) return "js/chunk.7763.8e27d785.js";
	if (chunkId === 8952) return "js/chunk.8952.850d8587.js";
	if (chunkId === 2206) return "js/chunk.2206.e8d4214c.js";
	if (chunkId === 8560) return "js/chunk.8560.c4ece7ee.js";
	if (chunkId === 339) return "js/chunk.339.840158ef.js";
	if (chunkId === 7646) return "js/chunk.7646.7262bd87.js";
	if (chunkId === 264) return "js/chunk.264.b787fc7d.js";
	if (chunkId === 170) return "js/chunk.npm-async-swr.f98ddb38.js";
	if (chunkId === 2107) return "js/chunk.npm-async-@blocksuite.6aa6195e.js";
	if (chunkId === 5028) return "js/chunk.5028.1a79d87d.js";
	if (chunkId === 1235) return "js/chunk.1235.26e1867e.js";
	if (chunkId === 5555) return "js/chunk.5555.a562a66c.js";
	if (chunkId === 6902) return "js/chunk.npm-async-@dotlottie.728ee29a.js";
	if (chunkId === 421) return "js/chunk.npm-async-html2canvas.ac7782a8.js";
	if (chunkId === 1006) return "js/chunk.npm-async-pdf-lib.a9f26190.js";
	if (chunkId === 2394) return "js/chunk.npm-async-@pdf-lib.28f82ba4.js";
	if (chunkId === 8385) return "js/chunk.npm-async-pako.812fe7c2.js";
	if (chunkId === 8772) return "js/chunk.npm-async-shiki.fb9debdb.js";
	if (chunkId === 9141) return "js/chunk.npm-async-@shikijs.ef669a52.js";
	if (chunkId === 4096) return "js/chunk.npm-async-@lottiefiles.b19c42ee.js";
	if (chunkId === 9296) return "js/chunk.9296.04204087.js";
	if (chunkId === 7719) return "js/chunk.7719.521d1ed2.js";
	if (chunkId === 5725) return "js/chunk.5725.4821a346.js";
	if (chunkId === 6323) return "js/chunk.6323.f5c9288a.js";
	if (chunkId === 1817) return "js/chunk.1817.a4fb30ba.js";
	if (chunkId === 9173) return "js/chunk.9173.12f71d2b.js";
	if (chunkId === 9465) return "js/chunk.npm-async-rxjs.e18db8d2.js";
	if (chunkId === 8852) return "js/chunk.8852.99aba8d7.js";
	if (chunkId === 1014) return "js/chunk.1014.1958d71c.js";
	if (chunkId === 214) return "js/chunk.214.d87efa7f.js";
	if (chunkId === 7876) return "js/chunk.7876.c99a94ef.js";
	if (chunkId === 2363) return "js/chunk.2363.6a14d0a5.js";
	if (chunkId === 9534) return "js/chunk.9534.06775f58.js";
	if (chunkId === 792) return "js/chunk.792.c02c4b7d.js";
	if (chunkId === 6293) return "js/chunk.6293.e6609dd8.js";
	if (chunkId === 1078) return "js/chunk.1078.7eefcb6a.js";
	if (chunkId === 238) return "js/chunk.238.38e7c09f.js";
	if (chunkId === 1475) return "js/chunk.1475.f321fd11.js";
	if (chunkId === 7933) return "js/chunk.auth.cf8cddab.js";
	if (chunkId === 6803) return "js/chunk.6803.4a90e54d.js";
	if (chunkId === 6258) return "js/chunk.6258.2180c6bf.js";
	if (chunkId === 2772) return "js/chunk.2772.df27d932.js";
	if (chunkId === 4023) return "js/chunk.4023.93c2b1c6.js";
	if (chunkId === 7364) return "js/chunk.7364.32e637bc.js";
	if (chunkId === 7090) return "js/chunk.7090.d550ad51.js";
	if (chunkId === 1643) return "js/chunk.1643.291e6a0a.js";
	if (chunkId === 3941) return "js/worker.658946bb.js";
	// return url for filenames based on template
	return undefined;
};